$.plugins.panel_mobile = {
	__init: function() {
		this.addClass('mobile');
		this.type = 'mobile';
		
		this.dimensions = {
			width: 1800,
			height: 108,
			font: 60,
			screen_width: 1920,
			screen_height: 1080,
		};
		
		this.rotate_device = $.div().addClass('rotate-device').appendTo(game);
		game.on('scale', function(e) {
			var width  = e.detail.viewport.width;
			var height = e.detail.viewport.height;
			
			var size = e.detail.resize(game.panel.dimensions, null, {
				width: width,
				height: height * game.panel.dimensions.height / game.panel.dimensions.screen_height,
			});
			
			game.panel.rotate_device.css('font-size', size.font + 'px');
		});
		/* Meters */
		{
			this.credits = $.div().apply('meter', { label: 'Bal', value: 0 });
			this.addItem(this.credits, 'bottom left');
			this.registerCash(this.credits, true);
			
			this.win = $.div().apply('meter', { label: 'Win', value: 0, animate: true });
			this.win.label.appendTo(this.win);
			this.addItem(this.win, 'bottom right');
			this.registerCash(this.win, true);
		}
		
		/* Play Button */
		{
			this.play = $.div().apply('button', { value: true });
			this.addItem(this.play, 'main right');
			
			this.play.on('click', function() {
				game.panel.hud.hide();
				
				if (this.hasClass('hide') || this.hasClass('disabled')) {
					return;
				}
				
				if (game.panel.state && game.panel.state === 'lock') {
					return;
				}
				
				if (game.panel.disabled) {
					this.emit('slam');
					
					return;
				}
				
				this.emit('play');
				game.sounds.play([ 'buttons', 'spin' ]);
			});
		}
		
		/* Menu Button */
		{
			this.menu = $.div().apply('button', {  });
			this.addItem(this.menu, 'main left icon-hud');
			
			this.menu.addMenu({
				callback: function() {
					if (this.disabled) {
						return false;
					}
					
					game.sounds.play([ 'buttons', 'menu' ]);
				},
			});
		}
		
		/* Help */
		{
			this.buildHelp = function(count) {
				this.help = [];
				this.help.slug = 'help';
				
				for (var i = 1; i <= count + 1; i++) {
					this.help.push($.div().addClass('help help-' + i));
				}
			};
		}
		
		/* HUD */
		{
			this.hud = this.menu.menu.addClass('hud').appendTo(this);
			this.menu.appendTo(this);
			this.registerMenu(this.hud);
			
			this.hud.help = $.div().apply('button', { label: 'Game Help' });
			this.addItem(this.hud.help, 'hud left top');
			this.hud.help.on('click', function() {
				game.panel.dialog.show(game.panel.help);
				game.panel.hud.hide();
				game.sounds.play([ 'buttons', 'help' ]);
			});
			
			this.hud.settings = $.div().apply('button', { label: 'Game Settings' });
			this.addItem(this.hud.settings, 'hud left bottom');
			this.hud.settings.on('click', function() {
				game.panel.dialog.show(game.panel.settings);
				game.panel.hud.hide();
				game.sounds.play([ 'buttons', 'menu' ]);
			});
			
			this.hud.bet = $.div().apply('button', { label: 'Bet' });
			this.addItem(this.hud.bet, 'hud right bottom');
			this.hud.bet.on('click', function() {
				if (game.panel.disabled) {
					return;
				}
				
				game.panel.dialog.show(game.panel.bet);
				game.panel.hud.hide();
			});
		}
		
		/* Betting */
		{
			this.bet = $.div();
			this.bet.slug = 'bet';
			this.bet.items = [];
			
			this.bet.max = $.div().apply('button', { label: 'Bet Max' }).addClass('max').appendTo(this.bet);
			this.bet.max.on('click', function() {
				if (game.panel.disabled) {
					return;
				}
				
				for (var i = 0; i < game.panel.bet.items.length; i++) {
					if (!game.panel.bet.items[i].max) {
						continue;
					}
					
					game.panel.bet.items[i].max();
				}
				
				game.sounds.play([ 'buttons', 'max' ]);
			});
			
			this.bet.play = $.div().apply('button', { label: 'Bet play' }).addClass('play').appendTo(this.bet);
			this.bet.play.on('click', function() {
				game.panel.dialog.hide();
			});
		}
		
		/* Settings */
		{
			this.settings = $.div();
			this.settings.slug = 'settings';
			
			this.settings.sound = $.div().apply('toggle', { label: 'Sound', value: true });
			this.settings.sound.addClass('sound');
			this.addItem(this.settings.sound, 'settings');
			this.settings.sound.on('update', function() {
				game.sounds.volume(this.is() ? 1 : 0);
				
				if (this.is()) {
					game.sounds.play([ 'buttons', 'sound' ]);
				}
			});
			
			this.settings.turbo = $.div().apply('toggle', { label: 'Turbo', value: false });
			this.settings.turbo.addClass('turbo');
			this.addItem(this.settings.turbo, 'settings');
			this.settings.turbo.on('update', function() {
				game.setTurbo(this.is());
				
				game.sounds.play([ 'buttons', 'turbo' ]);
			});
			
			this.settings.hand = $.div().apply('toggle', { label: 'Handedness', value: false });
			this.settings.hand.addClass('hand');
			this.addItem(this.settings.hand, 'settings');
			this.settings.hand.on('update', function() {
				game.toggleClass('flip-flop', this.is());
			});
			
			this.settings.recall = $.div().apply('button', { label: 'Game Recall' });
			this.settings.recall.addClass('recall');
			this.addItem(this.settings.recall, 'settings');
			this.settings.recall.on('click', function() {
				if (game.panel.disabled) {
					return;
				}
				
				game.panel.trigger('recall');
				game.sounds.play([ 'buttons', 'recall' ]);
			});
			
			this.settings.lobby = $.div().apply('button', { label: 'Back to Lobby' });
			this.settings.lobby.addClass('lobby');
			this.addItem(this.settings.lobby, 'settings');
			this.settings.lobby.on('click', function() {
				if (game.panel.disabled) {
					return;
				}
				
				game.panel.trigger('lobby');
				game.sounds.play([ 'buttons', 'lobby' ]);
			});
		}
	},
	
	addItem: function(item, position) {
		position = position.split(' ');
		
		if (has('main', false)) {
			item.appendTo(this);
		}
		
		else if (has('bet')) {
			item.appendTo(this.bet);
			this.bet.items.push(item);
		}
		
		else if (has('hud')) {
			item.appendTo(this.hud);
		}
		
		else if (has('settings')) {
			item.appendTo(this.settings);
		}
		
		else if (has('bottom', false)) {
			item.prependTo(this);
		}
		
		else {
			throw new Error('Panel: Unknown position: "' + position.join(' ') + '"');
		}
		
		item.addClass(position.join(' '));
		
		return item;
		
		function has(key, remove) {
			if (position.indexOf(key) === -1) {
				return false;
			}
			
			if (remove !== false) {
				position.splice(position.indexOf(key), 1);
			}
			
			return true;
		}
	},
	
	hide: function(value) {
		if (game.turbo && !value) {
			return;
		}
		
		this.menu.disabled = true;
		this.addClass('hide');
	},
	
	show: function() {
		this.removeClass('hide');
		this.menu.disabled = false;
	},
	
	metersHide: function() {
		for(let meter in this.metersCash) {
			this.metersCash[meter].addClass('hide');
		}
	},
	
	metersShow: function() {
		for(let meter in this.metersCash) {
			this.metersCash[meter].removeClass('hide');
		}
	},
};



/** WEBPACK FOOTER **
 ** /Users/kevinduarte/SG/roc2/engine/public-src/spingames/panel/js/core-mobile.js
 **/